class HbsRaportipsablonDTO {
    id: number = null;
    raportiptanimId?: number = null;
    adi?: string = "";
    ortaksablon?: string = "E";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    sablonStr?: string = "";
}
export default HbsRaportipsablonDTO;